import { createContext } from 'react';

/**
 * @typedef TitleObject
 * @property {string} title
 * @property {string[]} [breadcrumbs]
 * @property {number} [priority]
 */

const TitleContext = createContext({
    title: '',
    /**
     * @param {string | TitleObject} title
     * @returns {() => void} An unregister function
     */
    register(title) { throw new Error('No TitleContext in tree.'); }
});

export default TitleContext;